import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';
import { LEASE_COIN_COST_UNIT_OF_MEASURES } from '../../constants/rentDetailsConfig';

const initialState = {
  leaseForms: {
    rentDetails: {
      leaseName: '',
      location: null,
      sublocationsOfLocation: [],
      subLocation: [],
      city: '',
      state: '',
      zipCode: '',
      address1: '',
      address2: '',
      country: '',
      boothInfo: '',
      space: '',
      dba: '',
      leaseType: '',
      status: '',
      leaseBegins: null,
      leaseEnds: null,
      rentType: 'FEE_PLUS_RATE',
      rentRate: 0.0,
      calculationStarts: null,
      calculationEnds: null,
      breakpointNatural: true,
      breakpointValue: 0.0,
      breakpointRevenue: '',
      resetTerm: '',
      payFrequency: '',
      modalTypes: [],
      rentOptions: [],
      coinCostUom: LEASE_COIN_COST_UNIT_OF_MEASURES.DOLLAR,
      creditCardFeeRate: '',
      CAMFee: 0.0,
      rentFee: '',
      CAMRate: 0.0,
      thresholdRevenue: 0.0,
      breakpointRate: 0.0,
      notes: '',
      contractLink: '',
      inEffectFrom: null,
      tierSummaryState: [
        { startBreakpoint: 0.01, tierThreshold: '', tierRate: '' },
        { startBreakpoint: '', tierThreshold: '', tierRate: '' },
      ],
    },
  },
  leases: {
    data: [],
    pagination: {
      page: DEFAULT_PAGE,
      perPage: DEFAULT_PER_PAGE,
      total: 0,
      pages: 100,
    },
    isLoading: false,
    isError: false,
    isFetching: false,
  },
  searchApiParams: 'processStatus=&locationId=&leaseStatus=ACTIVE',
  page: DEFAULT_PAGE,
  perPage: DEFAULT_PER_PAGE,
};

export const leaseSlice = createSlice({
  name: 'lease',
  initialState,
  reducers: {
    leaseDetailsFormAction(state, action) {
      state.leaseForms.leaseDetails = action.payload;
    },
    rentDetailsFormAction(state, action) {
      const { payload } = action;
      const updatedTierSummaryState =
        payload.tierSummaryState && payload.tierSummaryState.length > 1
          ? payload.tierSummaryState
          : [
              { startBreakpoint: 0.01, tierThreshold: '', tierRate: '' },
              { startBreakpoint: '', tierThreshold: '', tierRate: '' },
            ];
      state.leaseForms.rentDetails = {
        ...state.leaseForms.rentDetails,
        ...payload,
        tierSummaryState: updatedTierSummaryState,
      };
    },
    leaseAndRentDetailsFormAction(state, action) {
      const { payload } = action;
      const updatedTierSummaryState =
        payload.tierSummaryState && payload.tierSummaryState.length > 1
          ? payload.tierSummaryState
          : [
              { startBreakpoint: 0.01, tierThreshold: '', tierRate: '' },
              { startBreakpoint: '', tierThreshold: '', tierRate: '' },
            ];
      state.leaseForms.leaseAndRentDetails = {
        ...state.leaseForms,
        ...payload,
        tierSummaryState: updatedTierSummaryState,
      };
    },
    setSearchApiParamsAction(state, action) {
      state.searchApiParams = action.payload;
    },
    setLeasesAction(state, action) {
      state.leases = action.payload;
    },
    setPageAction(state, action) {
      state.page = action.payload;
    },
    setPerPageAction(state, action) {
      state.perPage = action.payload;
    },
    resetLeaseAction(state) {
      Object.assign(state, initialState);
    },
  },
});

export default leaseSlice;
